// extracted by mini-css-extract-plugin
export default {"input_wrapper":"SettingsStyles_input_wrapper__aLBNA","button_container":"SettingsStyles_button_container__ZYNFq"};